import React from "react";
import { thisBaseURL } from "../../utils/helper.js";

function ProcessingSupplyChain({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let seasonalityYear = foodAnswers.answerKeyValues['seasonality_profile_year'];
	let seasonalitySourceRef = foodAnswers.answerKeyValues['seasonality_profile_sources'];
	let supplyChainYear = foodAnswers.answerKeyValues['supply_chain_characteristics_year'];
	let supplyChainSourceRef = foodAnswers.answerKeyValues['supply_chain_characteristics_sources'];
	let supplyChainNotes = foodAnswers.answerKeyValues['supply_chain_characteristics_notes'];
	let wayExportedYear = foodAnswers.answerKeyValues['way_exported_pkg_bulk__year'];
	let wayExportedSourceRef = foodAnswers.answerKeyValues['way_exported_pkg_bulk__sources'];
	let wayExportedNotes = foodAnswers.answerKeyValues['way_exported_pkg_bulk__notes'];
	
	let shippingPatternIntoUSYear = foodAnswers.answerKeyValues['shipping_pattern_into_us_year'];
	let shippingPatternIntoUSNotes = foodAnswers.answerKeyValues['shipping_pattern_into_us_notes'];
	let shippingPatternIntoUSSourceRef = foodAnswers.answerKeyValues['shipping_pattern_into_us_sources'];
	
	let typicalPackagingYear = foodAnswers.answerKeyValues['typical_packaging_year'];
	let typicalPackagingNotes = foodAnswers.answerKeyValues['typical_packaging_notes'];
	let typicalPackagingSourceRef = foodAnswers.answerKeyValues['typical_packaging_sources'];
	
	return (
		<div className="question-grouping" id="processing_and_supply_chain_characteristics">
			<h2>Processing and Supply Chain Characteristics</h2>
			<h3>
				Seasonality Profile
				{seasonalityYear ? 
				<small>&nbsp;({seasonalityYear})</small>
				: ""}
				{seasonalitySourceRef && seasonalitySourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+seasonalitySourceRef}>{seasonalitySourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['seasonality_profile']}</p>

			<h3>
				Supply Chain Characteristics
				{supplyChainYear ? 
				<small>&nbsp;({supplyChainYear})</small>
				: ""}
				{supplyChainSourceRef && supplyChainSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+supplyChainSourceRef}>{supplyChainSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['supply_chain_characteristics']}</p>
			{supplyChainNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{supplyChainNotes}</em>
				</p>
			: ""}
			
			<h3>
				Way Exported
				{wayExportedYear ? 
				<small>&nbsp;({wayExportedYear})</small>
				: ""}
				{wayExportedSourceRef && wayExportedSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+wayExportedSourceRef}>{wayExportedSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['way_exported_pkg_bulk_']}</p>
			{wayExportedNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{wayExportedNotes}</em>
				</p>
			: ""}
			
			<h3>
				Shipping pattern into US
				{shippingPatternIntoUSYear ? 
				<small>&nbsp;({shippingPatternIntoUSYear})</small>
				: ""}
				{shippingPatternIntoUSSourceRef && shippingPatternIntoUSSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+shippingPatternIntoUSSourceRef}>{shippingPatternIntoUSSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['shipping_pattern_into_us']}</p>
			{shippingPatternIntoUSNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{shippingPatternIntoUSNotes}</em>
				</p>
			: ""}
			
			<h3>
				Typical Packaging
				{typicalPackagingYear ? 
				<small>&nbsp;({typicalPackagingYear})</small>
				: ""}
				{typicalPackagingSourceRef && typicalPackagingSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+typicalPackagingSourceRef}>{typicalPackagingSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['typical_packaging']}</p>
			{typicalPackagingNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{typicalPackagingNotes}</em>
				</p>
			: ""}
		</div>
	);
	
}
export default ProcessingSupplyChain;